import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { AcademicsService } from 'src/app/service/academics.service';
import { EnrollmentGroupService } from 'src/app/service/enrollment-group.service';
import { formatDate, DatePipe } from '@angular/common';

@Component({
  selector: 'app-year-create',
  templateUrl: './year-create.component.html',
  styleUrls: ['./year-create.component.scss']
})
export class YearCreateComponent implements OnInit {

  showLoader: boolean = false;
  creating: boolean = false;

  createYear = new FormGroup({
    id: new FormControl('', [
      Validators.required,
    ]),
    nameAr: new FormControl('', [
      Validators.required,
    ]),
    nameEn: new FormControl('', [
      Validators.required,
    ]),
    abbriviation: new FormControl('', [
      Validators.required,
    ]),
    startDate: new FormControl('', [
      Validators.required,

    ]),
    endDate: new FormControl('', [
      Validators.required,
    ]),
    days: new FormControl(0, [
      Validators.required,
    ]),
  },
  );

  constructor(
    private toastrService: ToastrService
    , public globals: Globals, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private router: Router
    , public translate: TranslateService
    , public academicsService: AcademicsService
    , public enrollmentGroupService: EnrollmentGroupService
    , private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {

    this.createYear.controls.endDate.valueChanges.subscribe(value => {
      this.getcalendardayscount();
    });
    // this.createYear.controls.startDate.valueChanges.subscribe(value => {
    //   this.getcalendardayscount();
    // });
  }

  createYearChange() {
    // let classHours = this.createYear.controls.classHours.value;
    // let clinicalHours = this.createYear.controls.clinicalHours.value;
    // this.createYear.controls.totalHours.setValue(Number(classHours) + Number(clinicalHours));
  }

  createYearSubmit() {
    if (this.createYear.valid) {
      // console.log(this.createYear.value);
      let id = this.createYear.controls.id.value;
      let nameAr = this.createYear.controls.nameAr.value;
      let nameEn = this.createYear.controls.nameEn.value;
      let abbriviation = this.createYear.controls.abbriviation.value;
      let days = this.createYear.controls.days.value;
      let startDate = this.createYear.controls.startDate.value;
      let endDate = this.createYear.controls.endDate.value;

      this.addYear(id, nameAr, nameEn, abbriviation, days, startDate, endDate);
    }
    else {
      this.createYear.markAllAsTouched();
      this.createYear.markAsDirty();
    }
  }

  addYear(id: number, nameAr: string, nameEn: string, abbriviation: string, days: any, startDate: any, endDate: any) {
    this.creating = true;
    let username = this.globals.currentUserInfo.username;
    let orgid = this.globals.orgId;
    this.enrollmentGroupService.addYear(orgid, id, username, nameAr, nameEn, abbriviation, startDate, endDate, days)
      .subscribe(
        data => {
          if (data.sts == "SUCCESS") {
            // this.toastrService.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
            if (this.globals.lang == "ar") {
              this.toastrService.success(data.arMsg);
            } else {
              this.toastrService.success(data.enMsg);
            }
            this.router.navigate(['/academics/years']);
          } else if (data.sts == "CAUTION") {
            if (this.globals.lang == "ar") {
              this.toastrService.warning(data.arMsg);
            } else {
              this.toastrService.warning(data.enMsg);
            }
          } else {
            if (this.globals.lang == "ar") {
              this.toastrService.error(data.arMsg);
            } else {
              this.toastrService.error(data.enMsg);
            }

          }
          this.creating = false;
        },
        error => {
          this.creating = false;
          this.toastrService.error(this.translate.instant('FAIL_TO_CREATE'));
        }
      );
  }




  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  changeactive() {

  }
  getcalendardayscount() {
    console.log('getcalendardayscount');
     this.academicsService.getcalendardayscount(this.globals.orgId,this.createYear.controls.startDate.value,this.createYear.controls.endDate.value).subscribe(
       data => {
         //console.log('setting days:'+data);
         this.createYear.controls.days.setValue(data);
       });
  }
}

